import { WhatsappLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { AppBadges } from "./AppBadges";
import { WHATSAPP_URL, WHATSAPP_DISPLAY, ADMIN_URL } from "../../lib/site";

export const Footer = () => (
  <footer id="contato" className="bg-maraca-navy pt-24 text-white" data-testid="site-footer">
    <div className="mx-auto max-w-8xl px-5 md:px-10">
      <div className="grid gap-12 pb-16 md:grid-cols-[1.3fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white font-display text-lg font-extrabold text-maraca-navy">M</span>
            <span className="font-display text-xl font-extrabold">Delivery Maracás</span>
          </div>
          <p className="mt-4 max-w-xs text-white/60">
            O delivery da cidade de Maracás-BA. Comida, mercado, farmácia e serviços na palma da mão.
          </p>
          <AppBadges className="mt-6" />
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-widest text-maraca-teal">Navegação</h4>
          <ul className="mt-4 space-y-3 text-white/70">
            <li><a href="/#categorias" className="transition-colors hover:text-white">Categorias</a></li>
            <li><a href="/#como-funciona" className="transition-colors hover:text-white">Como funciona</a></li>
            <li><a href="/#lojistas" className="transition-colors hover:text-white">Lojistas</a></li>
            <li><a href={ADMIN_URL} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white">Painel do Lojista</a></li>
            <li><Link to="/termos" data-testid="footer-termos" className="transition-colors hover:text-white">Termos de Serviço</Link></li>
            <li><Link to="/privacidade" data-testid="footer-privacidade" className="transition-colors hover:text-white">Política de Privacidade</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-widest text-maraca-teal">Contato</h4>
          <ul className="mt-4 space-y-3 text-white/70">
            <li>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 transition-colors hover:text-white" data-testid="footer-whatsapp">
                <WhatsappLogo size={20} weight="fill" className="text-[#25D366]" /> {WHATSAPP_DISPLAY}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <EnvelopeSimple size={20} weight="fill" className="text-maraca-amber" /> contato@deliverymaracas.com.br
            </li>
          </ul>
        </div>
      </div>

      <div className="overflow-hidden py-8">
        <p className="text-center font-display text-[16vw] font-extrabold leading-none tracking-tighter text-stroke-cream md:text-[11rem]">
          MARACÁS
        </p>
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 text-sm text-white/50 md:flex-row">
        <p>© {new Date().getFullYear()} Delivery Maracás. Todos os direitos reservados.</p>
        <p>www.deliverymaracas.com.br</p>
      </div>
    </div>
  </footer>
);
